import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    restaurantSwitcherContainer: {
      display: 'flex',
      backgroundColor: '#EEEAE3',
      borderRadius: '20px',
      alignItems: 'center',
      padding: '12px',
      color: theme.colors.CHARCOAL,
      gap: '12px',
      cursor: 'pointer',
      userSelect: 'none',
      position: 'relative',
    },
    textOverflow: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      paddingTop: '2px',
    },
    restaurantDropdownArrow: {
      marginLeft: 'auto',
      color: theme.colors.BLACK,
      transitionDuration: '0.1s',
      flexShrink: 0,
      marginRight: '12px',
    },
    accountMenuContent: {
      pointerEvents: 'auto',
      backgroundColor: theme.colors.LINEN,
      padding: '12px',
      borderRadius: '20px',
      lineHeight: 'normal',

      [theme.breakpoints.down('sm')]: {
        marginLeft: '20px',
      },
    },
    navigationLinks: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      maxHeight: '500px',
      overflowY: 'scroll',
    },
    navigationLink: {
      padding: '6px 12px',
      borderRadius: '12px',
      cursor: 'pointer',
      userSelect: 'none',
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
      transition: 'all 0.1s',
      lineHeight: '30px',
      marginTop: '4px',
      flexShrink: 0,

      '&:hover': {
        backgroundColor: '#EEEAE3',
      },
    },
    divider: {
      marginTop: '8px',
      borderColor: '#E9E9E9',
    },
    logoContainer: {
      padding: '6px',
      borderRadius: '14px',
      background: '#FAD14A',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexShrink: 0,
    },
    restaurantAddress: {
      fontSize: '15px',
      color: theme.colors.smoke,
    },
    newLabel: {
      color: theme.colors.black,
      textTransform: 'uppercase',
      backgroundColor: '#FCFCCF',
      fontWeight: theme.fontWeights.medium,
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      height: '24px',
      padding: '0 6px',
      borderRadius: '4px',
      letterSpacing: 1.5,
    },
  }),
  { name: 'RestaurantSwitcher' },
);

export default useStyles;
